import { App } from 'vue';

import AppPage from '@/components/app-page';
import Pagination from '@/components/pagination';
import ConditionSelect from '@/components/condition-select';
import CopyText from '@/components/copy-text';
import _ResponsiveRow from '@/components/responsive-row';
import PageCard from '@/components/page-card';
import inputNumber from '@/components/input-number';
import Uploader from '@/components/uploader';
import ImageViewer from '@/components/image-viewer';
import Empty from '@/components/empty';

export default function componentsInstall(app: App) {
  app.use(AppPage);
  app.use(Pagination);
  app.use(ConditionSelect);
  app.use(CopyText);
  app.use(_ResponsiveRow);
  app.use(PageCard);
  app.use(inputNumber);
  app.use(Uploader);
  app.use(ImageViewer);
  app.use(Empty);
}
